import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import OfferingTable from "../components/OfferingTable";
import { useOfferings } from "../hooks/useOfferings";

import "../styles/offerings.css";


const OfferingsPage = () => {
  const navigate = useNavigate();

  const {
    offerings,
    loading,
    error,
    fetchOfferings,
    deleteOffering
  } = useOfferings();


  const [filters, setFilters] = useState({
    activeOnly: true,
    type: "",
    categoryId: ""
  });


  useEffect(() => {
    fetchOfferings(filters);
  }, [
    filters.activeOnly,
    filters.type,
    filters.categoryId
  ]);


  const handleFilterChange = (event) => {
    const {
      name,
      value
    } = event.target;

    setFilters((prev) => ({
      ...prev,
      [name]: value
    }));
  };


  const handleStatusFilterChange = (event) => {
    const value = event.target.value;

    setFilters((prev) => ({
      ...prev,
      activeOnly:
        value === "all"
          ? false
          : value === "active"
    }));
  };


  const handleDelete = async (offering) => {
    const confirmed = window.confirm(
      `Are you sure you want to delete "${offering.name}"?`
    );

    if (!confirmed) {
      return;
    }

    try {
      await deleteOffering(offering.id);

      await fetchOfferings(filters);
    } catch (error) {
      // Hook handles/display errors.
      console.error(error);
    }
  };


  return (
    <div className="offerings-page">

      <div className="page-header">

        <div>
          <h1>Offerings</h1>

          <p>
            Manage products, solutions and services.
          </p>
        </div>


        <button
          type="button"
          className="btn btn-primary"
          onClick={() =>
            navigate("/offerings/create")
          }
        >
          Create Offering
        </button>

      </div>


      <div className="offering-filters">

        <div className="filter-group">

          <label htmlFor="status">
            Status
          </label>

          <select
            id="status"
            value={
              filters.activeOnly
                ? "active"
                : "all"
            }
            onChange={handleStatusFilterChange}
          >
            <option value="active">
              Active
            </option>

            <option value="all">
              All
            </option>
          </select>

        </div>


        <div className="filter-group">

          <label htmlFor="type">
            Type
          </label>

          <select
            id="type"
            name="type"
            value={filters.type}
            onChange={handleFilterChange}
          >
            <option value="">
              All Types
            </option>

            <option value="PRODUCT">
              Product
            </option>

            <option value="SOLUTION">
              Solution
            </option>

            <option value="SERVICE">
              Service
            </option>
          </select>

        </div>


        <div className="filter-group">

          <label htmlFor="categoryId">
            Category
          </label>

          <input
            id="categoryId"
            name="categoryId"
            type="text"
            placeholder="Category ID"
            value={filters.categoryId}
            onChange={handleFilterChange}
          />

        </div>

      </div>


      {error && (
        <div className="error-message">
          {error}
        </div>
      )}


      <div className="offerings-card">

        {loading ? (
          <div className="loading-state">
            Loading offerings...
          </div>
        ) : offerings.length === 0 ? (
          <div className="empty-state">
            <h3>
              No offerings found
            </h3>

            <p>
              Create your first offering to get started.
            </p>

            <button
              type="button"
              className="btn btn-primary"
              onClick={() =>
                navigate("/offerings/create")
              }
            >
              Create Offering
            </button>
          </div>
        ) : (
          <OfferingTable
            offerings={offerings}
            onView={(offering) =>
              navigate(
                `/offerings/${offering.id}`
              )
            }
            onEdit={(offering) =>
              navigate(
                `/offerings/${offering.id}/edit`
              )
            }
            onDelete={handleDelete}
          />
        )}

      </div>

    </div>
  );
};


export default OfferingsPage;